import cn from "classnames";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { FONT_FAMILIES } from "@/fonts/catalog";
import { FontOptionButton } from "./FontOptionButton";
import styles from "./TextFontMenu.module.css";

interface TextFontMenuContentProps {
    recentFonts: string[];
    onTextFontButtonClick: (fontFamily: string) => void;
}

export const TextFontMenuContent = memo(
    ({ recentFonts, onTextFontButtonClick }: TextFontMenuContentProps) => {
        const { t } = useTranslation();
        return (
            <div className={cn(styles.listWrapper, "scrollable")}>
                <div className={styles.list}>
                    {recentFonts.length > 0 && (
                        <>
                            <div className={styles.title}>{t("textFont.recent")}</div>
                            {recentFonts.map((fontFamily) => {
                                return (
                                    <FontOptionButton
                                        key={`recent-${fontFamily}`}
                                        fontFamily={fontFamily}
                                        onClick={onTextFontButtonClick}
                                    />
                                );
                            })}
                            <div className={styles.separator} />
                        </>
                    )}

                    {FONT_FAMILIES.map((fontFamily) => {
                        return (
                            <FontOptionButton
                                key={`all-${fontFamily}`}
                                fontFamily={fontFamily}
                                onClick={onTextFontButtonClick}
                            />
                        );
                    })}
                </div>
            </div>
        );
    },
);
